import { render, staticRenderFns } from "./LocumPastBookings.vue?vue&type=template&id=de6241e4&"
import script from "./LocumPastBookings.vue?vue&type=script&lang=js&"
export * from "./LocumPastBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports